import { render, staticRenderFns } from "./GeneralDocuments.vue?vue&type=template&id=413588a4&scoped=true&"
import script from "./GeneralDocuments.vue?vue&type=script&lang=js&"
export * from "./GeneralDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDocuments.vue?vue&type=style&index=0&id=413588a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413588a4",
  null
  
)

export default component.exports